var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCofreElectronico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-cofre-electronico",
    transform: "translate(14694 18568)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2076",
    "data-name": "Rect\\xE1ngulo 2076",
    width: 46,
    height: 46,
    transform: "translate(-14694 -18568)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "safe-svgrepo-com",
    d: "M7.857,31.2h4.857m9.714,0h4.857M26.475,8.483V21.017M3,8.013V21.487c0,1.755,0,2.632.353,3.3a3.187,3.187,0,0,0,1.415,1.369c.693.342,1.6.342,3.413.342h18.78c1.813,0,2.72,0,3.413-.342a3.187,3.187,0,0,0,1.415-1.369c.353-.67.353-1.548.353-3.3V8.013c0-1.755,0-2.632-.353-3.3a3.187,3.187,0,0,0-1.415-1.369C29.681,3,28.774,3,26.961,3H8.181c-1.813,0-2.72,0-3.413.342A3.188,3.188,0,0,0,3.353,4.711C3,5.381,3,6.259,3,8.013ZM16.761,14.75a3.984,3.984,0,0,1-4.047,3.917,3.919,3.919,0,1,1,0-7.833A3.984,3.984,0,0,1,16.761,14.75Z",
    transform: "translate(-14688.358 -18561.768)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCofreElectronico);
export default __webpack_public_path__ + "static/media/icon-cofre-electronico.387270f71bbfa4d788f432ccf25a56ad.svg";
export { ForwardRef as ReactComponent };